import React, { useMemo, useState } from 'react';
import { useSearch, useTranslate } from '../../../../../../hooks';
import { useGetTableLayout } from '../../../../hooks';


import { baseDateFormatting } from '../../../../../../helpers/utils';

import SearchSeaction from './components/SearchSeaction';
import DefaultTableBodyCell from '../../../../../../components/table/DefaultTableBodyCell';
import ActionField from './components/ActionField';
import { DateField, Table } from '../../../../../../components';
import { Modal } from '@mui/material';
import LoaderCotainer from '../../../components/LoaderCotainer';
import EditLocalizationStatus from './components/EditLocalizationStatus';
import { useNavigate } from 'react-router';
import { useConfigDelete, useConfigEdit, useConfigList } from '../../../../api';
import { CONFIG_ID } from '../../../utils';

function LocalizationStatus() {
  const [editModal, setEditModal] = useState(false);
  const [modalData, setModalData] = useState({});

  const { translate } = useTranslate();
  const navigate = useNavigate();
  const [titleSearch, setTitleSearch] = useSearch('');
  const { layout } = useGetTableLayout({ type: 1 });

  const { data, isLoading, count, refetch } = useConfigList({
    params: { configId: CONFIG_ID?.localizationStatus, name: titleSearch },
  });
  const { editConfig, isEditing } = useConfigEdit
    ({
      id: modalData.id,
      params: { configId: CONFIG_ID?.localizationStatus },
    });
  const { deleteConfig, isDeleting } = useConfigDelete({
    params: { configId: CONFIG_ID?.localizationStatus },
  });

  const toggleEditModal = () => {
    setEditModal((state) => !state);
  };

  const handleEditModal = (data) => {
    setModalData(() => data);
    toggleEditModal();
  };

  const onEditLocalizationStatus = (data) => {
    editConfig({ name: data?.name }).then(() => {
      toggleEditModal();
      refetch();
    });
  };

  const onDelete = ({ data }) => {
    console.log(data);
    deleteConfig(data?.id).then(() => refetch());
  };

  const columns = useMemo(
    () => [
      {
        name: 'typeId',
        label: translate('Type Id'),
        options: {
          customBodyRender: (value) => {
            return <DefaultTableBodyCell value={value} />;
          },
        },
      },
      {
        name: 'localizationStatusName',
        label: translate('Localization Status Name'),
        options: {
          customBodyRender: (value) => {
            return <DefaultTableBodyCell value={value} />;
          },
        },
      },
      // {
      //   name: 'isDisabledGratuity',
      //   label: translate('Is Disabled Gratuity'),
      //   options: {
      //     customBodyRender: (value) => {
      //       return <DefaultTableBodyCell value={value} />;
      //     },
      //   },
      // },
      {
        name: 'createdAt',
        label: translate('Created At'),
        options: {
          customBodyRender: (value) => {
            return <DateField value={value} format={baseDateFormatting} />;
          },
        },
      },
      {
        name: 'updatedAt',
        label: translate('Updated At'),
        options: {
          customBodyRender: (value) => {
            return <DateField value={value} format={baseDateFormatting} />;
          },
        },
      },
      {
        name: 'action',
        label: translate('Action'),
        options: {
          setCellHeaderProps: () => ({
            align: 'center',
            style: { fontWeight: '600' },
          }),
        },
      },
    ],

    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );
  const tableData = useMemo(
    () => {
      const res = data?.map((item) => {
        return {
          typeId: item?.id,
          localizationStatusName: item?.name,
          isDisabledGratuity: item?.is_disabled_gratuity,
          createdBy: item?.created_by,
          createdAt: item?.created_at,
          updatedAt: item?.updated_at,
          action: (
            <ActionField
              localizationStatusName={item.localizationStatusName}
              // onEdit={() => {
              //   handleEditModal(item);
              // }}
              onReject={() => onDelete({ data: item })}
              isRejecting={isDeleting}
              className="justify-center"
              newCancelLayout={true}
            />
          ),
        };
      });

      return res;
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [data, isDeleting],
  );
  const onCreate = () => {
    navigate('create', {
      state: { complocalizationList: data },
    });
  };
  return (
    <>
      <SearchSeaction
        handleSearchTitle={setTitleSearch}
        openAddDesignation={onCreate}
      />
      {isLoading ? (
        <LoaderCotainer />
      ) : (
        <div className="mt-4">
          <Table
            columns={columns}
            data={tableData || []}
            count={count}
            options={{ ...layout }}
          />
        </div>
      )}
      <Modal open={editModal} onClose={toggleEditModal}>
        <EditLocalizationStatus
          toggleModal={toggleEditModal}
          customHandler={onEditLocalizationStatus}
          seletedData={modalData}
          isEditing={isEditing}
        />
      </Modal>
    </>
  );
}

export default LocalizationStatus;
